module.exports = __webpack_public_path__ + "static/img/5.33fc226.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/5.png
// module id = d/5S
// module chunks = 0